import { computed } from 'vue';
import { installationDisplayName } from './branding';
import { useMapGetter } from 'dashboard/composables/store';
import fianlyLogo from './assets/logo-fianly.png';

// Keep installation-specific branding; replace only the upstream defaults.
export function useFianlyBranding() {
  const config = useMapGetter('globalConfig/get');
  const installationName = computed(() =>
    installationDisplayName(config.value.installationName)
  );
  const logo = computed(() =>
    !config.value.logo || config.value.logo === '/brand-assets/logo.svg'
      ? fianlyLogo
      : config.value.logo
  );
  const logoDark = computed(() =>
    !config.value.logoDark ||
    config.value.logoDark === '/brand-assets/logo_dark.svg'
      ? logo.value
      : config.value.logoDark
  );
  const replaceInstallationName = text =>
    text.replace(/chatwoot/gi, installationName.value);

  return { installationName, logo, logoDark, replaceInstallationName };
}
